import { useT } from '../i18n/LocaleProvider.js';

/**
 * 광고 중의 버튼 둘 — **개인화 채널(`ControlBar`)과 ONAIR CSPM(`OnairScreen`)이 같이 쓴다** (v38 · `docs/77` §5.5 · D10).
 * 두 벌이 되면 한쪽만 고쳐진다 — 그래서 꺼냈다(꺼낸 커밋은 동작 변화 0 · 개인화 채널의 하네스로 묶는다).
 *
 * 둘 다 네이티브 `<button>` 이다(절대 규칙 29·30 — 포커스 후보 · 활성화는 버튼이 한다).
 */

/**
 * v21. **광고 중의 구매.** `data-testid="purchase"` 를 재사용하지 않는다 —
 * `verify-general-channel` 완료 조건 ①이 「일반 채널 DOM 에 `purchase` 가 없다」를
 * 재고 있어서, 재사용하면 **그 검사가 광고 때문에 빨개진다.**
 *
 * **재생을 멈추지 않는다** (절대 규칙 51). 오버레이만 뜬다.
 */
export function AdPurchaseButton({
  handoffOpen,
  handoffPending,
  onClick,
}: {
  handoffOpen: boolean;
  handoffPending: boolean;
  onClick: () => void;
}) {
  const t = useT();
  return (
    <button
      type="button"
      className={`controls__button${handoffOpen ? ' is-on' : ''}`}
      data-testid="ad-purchase"
      onClick={onClick}
      disabled={handoffPending}
      aria-pressed={handoffOpen}
    >
      {handoffPending ? t('watch.requesting') : t('watch.adPurchase')}
    </button>
  );
}

/**
 * v21. **광고 중에는 광고 스킵이다** — 다른 `testid`·다른 핸들러·다른 문구. 하나로 겸하면 `send('skip')` 이
 * **회차 이탈률을 광고 스킵으로 부풀린다.** 보이지 않으면 그리지 않는다(비활성으로 두면 「조금 기다리면 누를 수 있다」는
 * 잘못된 신호다).
 */
export function AdSkipButton({
  skip,
  onClick,
}: {
  skip: { visible: boolean; enabled: boolean; secondsLeft: number };
  onClick: () => void;
}) {
  const t = useT();
  if (!skip.visible) return null;
  return (
    <button
      type="button"
      className="controls__button controls__button--skip"
      data-testid="ad-skip"
      onClick={onClick}
      disabled={!skip.enabled}
    >
      {skip.enabled ? t('watch.adSkip') : t('watch.adSkipIn', { n: skip.secondsLeft })}
    </button>
  );
}
